/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import HomePageBanner from "../components/Home/HomePageBanner";
import HomePageDetails from "../components/Home/HomePageDetails";
import Equipment from "../components/Home/Equipment";
import MarqueeText from "../components/Home/MarqueeText";
import GetINTouch from "../components/Contactus/GetINTouch";
import { useLenis } from "../components/SmoothScroll";
import Certificates from "../components/Home/Certificates";
import WelComeCDC from "../components/Home/WelComeCDC";
import Insurance from "../components/Home/Insurance";
const HomePage = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, []);
  return (
    <>
      <title>Best Diagnostic Imaging Center | Citrus Diagnostic Center</title>
      <meta
        name="description"
        content="Citrus Diagnostic Center offers advanced MRI scans, ultrasound clinics, and diagnostic medical imaging with precision and care for accurate health outcomes."
      />
      <HomePageBanner />
      <WelComeCDC />
      <Equipment />
      <MarqueeText />
      <HomePageDetails />
      <Certificates />
      <Insurance />
      <GetINTouch />
    </>
  );
};

export default HomePage;
